import { Button } from "../buttons/Button/Button";
import { Dropdown } from "../Dropdown/Dropdown";
import { countriesArray, languagesArray } from "./assets";

export const CountrySelectorMenu = ({onOpenMenu}) => {
  return (
    <div className="country-selector-menu">
      <h4>Change country</h4>
      <Button type="close" onClick={onOpenMenu}></Button>
      <form>
        <Dropdown label="PLEASE CHOOSE A COUNTRY" options={countriesArray} />
        <Dropdown label="AVAILABLE LANGUAGES" options={languagesArray} />
        <Button type="default">SAVE YOUR CHOICE</Button>
      </form>
    </div>
  );
};
